var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaderboard__start-tournament-button"},[_c('button',{staticClass:"button button-primary",on:{"click":function($event){$event.preventDefault();return _vm.start.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Generate lobbies'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }